import React from "react";

function GetAssistance() {
  return (
    <div style={{ padding: "30px" }}>
      <h1>Roadside Help</h1>
      <p>Immediate support for breakdowns, recovery and on‑site assistance.</p>

      <div style={{ marginTop: "20px" }}>
        <label>Location:</label>
        <input
          type="text"
          placeholder="Enter your location"
          style={{
            display: "block",
            marginTop: "10px",
            padding: "10px",
            width: "300px"
          }}
        />

        <label style={{ marginTop: "20px" }}>Type of Issue:</label>
        <input
          type="text"
          placeholder="Flat tyre, engine issue, battery, etc."
          style={{
            display: "block",
            marginTop: "10px",
            padding: "10px",
            width: "300px"
          }}
        />

        <label style={{ marginTop: "20px" }}>Phone Number:</label>
        <input
          type="text"
          placeholder="Your phone number"
          style={{
            display: "block",
            marginTop: "10px",
            padding: "10px",
            width: "300px"
          }}
        />

        <button
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            background: "#0A3D62",
            color: "white",
            border: "none"
          }}
        >
          Call Now
        </button>
      </div>
    </div>
  );
}

export default GetAssistance;
